import { Box } from '@chakra-ui/react';
import React from 'react';

import { url as commonUrl } from '@finley-technologies/common';

export const AddToSlackButton = () => {
  const slackInstallUrl = commonUrl.getSlackInstallUrl();

  return (
    <Box width="139px">
      <a href={slackInstallUrl} target="_blank" rel="noreferrer noopener">
        <img
          alt="Add to Slack"
          height="40"
          width="139"
          src="https://platform.slack-edge.com/img/add_to_slack.png"
          srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
        />
      </a>
    </Box>
  );
};
